import {Pages} from 'shared/config/model/pages';
import {AppUrls} from 'shared/config/model/urls';

import React, {useCallback} from 'react';
import {i18n} from '@lingui/core';
import {t} from '@lingui/core/macro';

import {tariffAPI, ITariff} from 'entities/tariff';
import ListPage from 'shared/ui/ListPage/ListPage';
import ListToolbar from 'shared/ui/ListToolbar/ListToolbar';
import TableToolbar from 'shared/ui/TableToolbar/TableToolbar';
import ListFiltersModal from 'shared/ui/Modal/ListFiltersModal/ListFiltersModal';
import useOpenState from 'shared/lib/hooks/useOpenState';
import useListParams from 'shared/lib/hooks/useListParams';

import {TARIFF_FILTER_KEYS} from '../../lib/adminFilterKeys';
import TariffRow from './TariffRow/TariffRow';
import CreateTariffButton from './CreateTariffButton';
import TariffsFiltersForm from './TariffsFiltersForm/TariffsFiltersForm';


const TABLE_COLUMNS = [
    {label: 'Тариф', sort: 'name', key: 'name'},
    {label: 'Стоимость', sort: 'price', key: 'price'},
    {label: 'Мониторинг', key: 'monitoring'},
    {label: 'Страницы и отчёты', key: 'pages'},
    {label: 'Проверки', key: 'features'},
    {label: 'Уведомления', key: 'notifications'},
    {label: '', key: 'actions'},
];

const Tariffs: React.FC = () => {
    const {sort, setSort, filters, hasFilters, search, onSearch} = useListParams({
        filterKeys: TARIFF_FILTER_KEYS,
        resetPage: false,
    });
    const filtersModal = useOpenState();
    const {data: items, isLoading} = tariffAPI.useGetAdminTariffsQuery({sort, filters});

    const renderRow = useCallback((item: ITariff) => (
        <TariffRow key={item.id} item={item}/>
    ), []);

    return (
        <ListPage
            documentTitle={`${t`Редактор тарифов`} | ${t`Overseer`}`}
            toolbar={
                <ListToolbar
                    title={i18n._(Pages.ADMIN_TARIFFS)}
                    backUrl={AppUrls.SETTINGS}
                    createButton={<CreateTariffButton/>}
                    actions={
                        <TableToolbar
                            onSearch={onSearch}
                            searchValue={search}
                            onFilter={filtersModal.open}
                        />
                    }
                />
            }
            columns={TABLE_COLUMNS}
            items={items}
            rowFactory={renderRow}
            isLoading={isLoading}
            sort={sort}
            setSort={setSort}
            emptyStateComponent={hasFilters ? t`Ничего не найдено` : undefined}
        >
            <ListFiltersModal open={filtersModal.isOpen} handleClose={filtersModal.close} Form={TariffsFiltersForm}/>
        </ListPage>
    );
};

export default React.memo(Tariffs);
